import React from "react";
import semanticVariables from "ui-v2/styles/semantic_colors.module.scss";

export default ({ width = 24, height = 24, color = "primary" }) => {
  const colorValue = semanticVariables?.[`semantic_icon_${color}`];
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M14.656 3.071a50 50 0 0 0-5.312 0h-.005a2.94 2.94 0 0 0-2.328 1.393l-.82 1.312a1.56 1.56 0 0 1-1.106.71l-.005.001q-.577.082-1.151.178C2.497 6.903 1.5 8.16 1.5 9.574V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V9.574c0-1.416-.998-2.67-2.429-2.909a49 49 0 0 0-1.152-.178h-.003a1.56 1.56 0 0 1-1.107-.711v-.002l-.82-1.31a2.94 2.94 0 0 0-2.328-1.393zm-5.882 1.7c.198-.119.422-.188.653-.202a48 48 0 0 1 5.146 0 1.44 1.44 0 0 1 1.14.683l.825 1.32.002.004a3.06 3.06 0 0 0 2.17 1.397q.558.08 1.115.172c.673.112 1.175.71 1.175 1.429V18a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 3 18V9.574c0-.719.502-1.317 1.176-1.43q.554-.092 1.114-.171A3.06 3.06 0 0 0 7.46 6.576l.823-1.32.003-.004c.121-.197.288-.362.487-.481"
        clipRule="evenodd"
      ></path>
      <path
        fill={colorValue}
        fillRule="evenodd"
        d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9m-3.712.038a5.25 5.25 0 1 1 7.424 7.424 5.25 5.25 0 0 1-7.424-7.424M18 10.5a.75.75 0 0 1 .75-.75h.008a.75.75 0 0 1 .75.75v.008a.75.75 0 0 1-.75.75h-.008a.75.75 0 0 1-.75-.75z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};
